import React,{useState,useEffect} from 'react';
import axios from 'axios';

const AnalysisSearch = ({varSearchData,setSearchData,setPageNum,varBranchList,varYearList,varMonthList}) => {
  //항목별 검색변수값 설정
  const [varSearchBranch, setSearchBranch] = useState(varSearchData.searchBranch);
  const [varSearchSemester, setSearchSemester] = useState(varSearchData.searchSemester);
  const [varSearchYear, setSearchYear] = useState(varSearchData.searchYear);
  const [varSearchMonth, setSearchMonth] = useState(varSearchData.searchMonth);
  const [varSearchOption, setSearchOption] = useState(varSearchData.searchOption);
  const [varSearchString, setSearchString] = useState(varSearchData.searchString);

  //학기 목록
  const [varSemesterList,setSemesterList] = useState([]);

  //학기목록 호출
  const GetSemesterList = async(bh_idx) => {
    const sendData = {bh_idx: bh_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_semester_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setSemesterList(datas.results);
      }
    });
  }

  useEffect(() => {
    GetSemesterList(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //검색항목 선택값 저장
  const onSearchBranchHandler = (e) => {   
    const bh_idx = Number(e.currentTarget.value);  
    setSearchBranch(bh_idx);
    if(bh_idx === 0) {
      setSemesterList([]);
    } else {
      GetSemesterList(bh_idx);
    }
    setSearchData({...varSearchData,searchBranch:bh_idx,searchSemester:0});
    setPageNum(1);
  }

  //검색항목 선택값 (학기) 저장
  const onSearchSemesterHandler = (e) => { 
    const sm_idx = Number(e.currentTarget.value);  
    setSearchSemester(sm_idx);
    setSearchData({...varSearchData,searchSemester:sm_idx});
    setPageNum(1);
  }
  //검색항목 선택값 저장
  const onSearchYearHandler = (e) => {   
    setSearchYear(Number(e.currentTarget.value));
  }
  //검색항목 선택값 저장
  const onSearchMonthHandler = (e) => {   
    setSearchMonth(Number(e.currentTarget.value));
  }
  //검색항목 선택값 저장
  const onSearchOptionHandler = (e) => {   
    setSearchOption(e.currentTarget.value);
  }

  //검색문자 저장
  const onSearchStringHandler = (e) => {   
    setSearchString(e.currentTarget.value);
  }

  //검색시작
  const onExecuteSearchingHandler = (e) => {
    e.preventDefault();
    setSearchData({searchBranch:varSearchBranch,searchSemester:varSearchSemester,searchYear:varSearchYear,searchMonth:varSearchMonth,
                  searchOption:varSearchOption,searchString:varSearchString});
    setPageNum(1);
  }

  //검색정보 초기화
  const onClearSearchHandler = (e) => {
    e.preventDefault();
    setSearchData({searchBranch:0,searchSemester:0,searchYear:0,searchMonth:0,searchOption:"all",searchString:""});
    setPageNum(1);
    setSearchBranch(0);
    setSearchSemester(0);
    setSearchYear(0);
    setSearchMonth(0);
    setSearchOption("all");
    setSearchString("");
  }

  return (
    <div className="main-box" style={{height:"60px"}}>
      <div className="search-area" style={{position:"relative"}}>
        <div className="search-options" style={{position:"absolute",left:"0px"}}>
          <select value={varSearchBranch} style={{width:"150px"}} onChange={(e)=>onSearchBranchHandler(e)}>
            <option value={0}>센터 전체</option>
            {varBranchList.map((branchs,i)=>(
              <option key={'branchs_'+i} value={branchs.bh_idx}>{branchs.bh_company}</option>
            ))}
          </select>&nbsp;
          <select value={varSearchSemester} style={{width:"200px"}} onChange={(e)=>onSearchSemesterHandler(e)}>
            <option value={0}>학기 선택</option>
            {varSemesterList.map((semesters,i)=>(
              <option key={'semesters_'+i} value={semesters.sm_idx}>{semesters.sm_name}</option>
            ))}
          </select>
        </div>
        <div className="search-string" style={{position:"absolute",right:"0px"}}>
          <select value={varSearchYear} style={{width:"150px"}} onChange={(e)=>onSearchYearHandler(e)}>
            <option value={0}>년도 전체</option>
            {varYearList.map((years,i)=>(
              <option key={'years_'+i} value={years}>{years}</option>
            ))}
          </select>&nbsp;&nbsp;
          <select value={varSearchMonth} style={{width:"150px"}} onChange={(e)=>onSearchMonthHandler(e)}>
            <option value={0}>월 전체</option>
            {varMonthList.map((months,i)=>(
              <option key={'months_'+i} value={months}>{months}</option>
            ))}
          </select>&nbsp;&nbsp;
          <select value={varSearchOption} style={{width:"150px"}} onChange={(e)=>onSearchOptionHandler(e)}>
              <option value={"all"}>전체</option>
              <option value={"ch_name"}>원생명</option>
              <option value={"sm_name"}>학기명</option>
              <option value={"cl_name"}>클래스명</option>
          </select>
          <input type="text" value={varSearchString} onChange={(e)=>onSearchStringHandler(e)} placeholder="검색어를 입력해주세요"/>
          <button onClick={(e)=>onExecuteSearchingHandler(e)} className="btn">조회</button>
          <button onClick={(e)=>onClearSearchHandler(e)} className="btn black">초기화</button>
        </div>
      </div>
    </div>
  )
}
export default AnalysisSearch;